exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".product-list-load-more-component{width:100%;padding:20px 0}.product-list-load-more-component .btn-load-more{margin:20px auto 80px auto;display:block}\n", ""]);
